/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Keen_Frog_CureInputs */

const fr_sharp_keen_frog_cure = /** @type {(inputs: Sharp_Keen_Frog_CureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

/**

* @param {Sharp_Keen_Frog_CureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sharp_keen_frog_cure = /** @type {((inputs?: Sharp_Keen_Frog_CureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Keen_Frog_CureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sharp_keen_frog_cure(inputs)
});